import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  data: PropTypes.object,
  onChange: PropTypes.func
}

export default class Propagable extends React.Component {

  componentWillReceiveProps(props) {
    const { data } = props
    if (data) {
      this.setState(data)
    }
  }

  propagate = (state) => {
    this.props.onChange(state)
  }

  handleChange = field => value => {
    this.setState(state => {
      state[field] = value
      this.propagate(state)
      return state
    })
  }
}

Propagable.propTypes = propTypes